import { IframeViscom } from 'ui/components';

export const IframeViscomFeature: React.FC<Umbraco.IframeViscom> = ({ content }) => {
	return <IframeViscom {...content?.properties} />;
};
